<template>
  <b-container fluid>
    <div v-if="loading">
      <loading-overlay :isLoading="loading" :loadingText="'Loading User'" />
    </div>
    <div v-else-if="errorMessage !== ''" class="d-flex justify-content-center">
      <b-card title="Error" class="p-5">
        <b-card-text>{{ errorMessage }}</b-card-text>
      </b-card>
    </div>
    <div v-else-if="user.UserId === 0" class="d-flex justify-content-center">
      <b-card title="404" class="p-5">
        <b-card-text>Error - User not found</b-card-text>
      </b-card>
    </div>
    <div v-else>
      <b-card>
        <!-- Row 1 -->
        <b-row class="align-items-center pb-3 my-1">
          <b-col md="8">
            <h5>
              <span
                v-if="_hasHistory()"
                class="mr-4 primary-color back-btn"
                @click="$router.back()">
                <b-icon icon="arrow-left"></b-icon>
              </span>
              <i class="fa fa-user fa-lg mr-2"></i>User Details
            </h5>
          </b-col>
        </b-row>

        <!-- Row 4 -->
        <b-row class="my-3">
          <b-col md="12">
            <b-row>
              <b-col md="12" class="info-section" style="border-color: #a6c2ef">
                <b-row
                  class="justify-content-between align-items-center p-1 border-y"
                  style="
                    background-color: #e7f0f8;
                    border-color: #a6c2ef;
                    margin-left: -1.25rem;
                    margin-right: -1.25rem;
                  ">
                  <b-col><b>Information</b></b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col cols="4">User name:</b-col>
                  <b-col cols="8"><u><b>{{ user.Username }}</b></u></b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col cols="4">First Name:</b-col>
                  <b-col cols="4" v-if="_isSalesRepSite(site.Name) || _isCustomerSite(site.Name)">
                    <b-form-input id="userName" v-model="user.Name" placeholder="Type your name" :state="user?.Name !== null && user?.Name?.length > 0"></b-form-input>
                  </b-col>
                  <b-col cols="4" v-else>
                    {{ user.Name }}
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col cols="4">Last Name:</b-col>
                  <b-col cols="4" v-if="_isSalesRepSite(site.Name) || _isCustomerSite(site.Name)"><b-form-input id="userLastName" v-model="user.LastName" placeholder="Type your lastname" :state="user?.LastName !== null && user?.LastName?.length > 0"></b-form-input></b-col>
                  <b-col cols="8" v-else>{{ user.LastName }}</b-col>
                </b-row>
                <b-row class="my-2" v-if="(_isSalesRepSite(site.Name) || _isCustomerSite(site.Name)) && user.AuthProviderType === 'AD'">
                  <b-col cols="4">Email:</b-col>
                  <b-col cols="4"><b-form-input type="email" required id="userEmail" v-model="user.Email" placeholder="Type your email" :state="emailRegex.test(user.Email ?? '')"></b-form-input></b-col>
                </b-row>
                <b-row class="my-2" v-else-if="!_isSalesRepSite(site.Name) || _isCustomerSite(site.Name)">
                  <b-col cols="4">Email:</b-col>
                  <b-col cols="8">{{ user.Email }}</b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col cols="4">
                  </b-col>
                  <b-col cols="4 float-right" v-if="_isSalesRepSite(site.Name) || _isCustomerSite(site.Name)">
                    <b-button size="sm" variant="info" type="submit" class="background-color-primary mb-2" :disabled="!validateUser() || isLoading" @click="saveProfile()">
                      Update Profile
                    </b-button>
                  </b-col>
                </b-row>
                <template v-if="_isCustomerAdminSite(role ?? '')">
                  <b-row class="my-2">
                    <b-col cols="4">Status:</b-col>
                    <b-col cols="8">
                      <b-form-checkbox v-model="userDisabled" :state="!userDisabled" @change="onActivate">
                        {{ userDisabled  ? 'Locked' : 'Unlocked' }}
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col cols="4">Updated by:</b-col>
                    <b-col cols="8">
                      {{ user.DisabledByUserName }}
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col cols="4">Comment:</b-col>
                    <b-col cols="8">
                      {{ user.Comment }}
                    </b-col>
                  </b-row>
                </template>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-tabs content-class="mt-3" justified lazy>
          <b-tab title="Sales Representatives" v-if="_isCustomerAdminSite(role ?? '') || _isSalesRepSite(site.Name)">
            <b-button size="sm" variant="info" class="background-color-primary mb-2" @click="onAddPermissions('SalesRep')" v-if="_isCustomerAdminSite(role ?? '')">
              <b-icon icon="plus"></b-icon>
              Add Sales Rep
            </b-button>
            <b-button v-if="_isSalesRepSite(site.Name)" size="sm" variant="info" class="background-color-primary mb-2" @click="onAddPermissions('SalesRep')">
              <b-icon icon="plus"></b-icon>
              Request Permissions
            </b-button>
            <b-row class="justify-content-between align-items-center p-1 border-y" style="
                    background-color: #e7f0f8;
                    border-color: #a6c2ef;
                    margin-left: -1.25rem;
                    margin-right: -1.25rem;
                  ">
              <b-col sm="2"><b>Sales Rep Number</b></b-col>
              <b-col sm="3"><b>Sales Rep Name</b></b-col>
              <b-col sm="2"><b>City</b></b-col>
              <b-col sm="2"><b>State</b></b-col>
              <b-col sm="2"><b>Zipcode</b></b-col>
              <b-col sm="1"></b-col>
            </b-row>
            <b-row class="my-2" v-if="!user.SalesRepPermissions.length">
              <b-col>This user has no sales representative</b-col>
            </b-row>
            <b-row class="my-2" v-for="salesRep in user.SalesRepPermissions" :key="salesRep.Id">
              <b-col sm="2">
                <router-link :to="{
                  name: _isCustomerAdminSite(role ?? '') ? 'sales-rep-profile' : 'sales-rep-profile-single',
                  params: { salesRepNumber: salesRep.ResourceId },
                }">
                  {{ salesRep.ResourceId }}
                </router-link>
              </b-col>
              <b-col sm="3">
                {{ salesRep.ResourceName }}
              </b-col>
              <b-col sm="2">
                {{ salesRep.City }}
              </b-col>
              <b-col sm="2">
                {{ salesRep.State }}
              </b-col>
              <b-col sm="2">
                {{ salesRep.PostalCode }}
              </b-col>
              <b-col sm="1">
                <b-button v-if="_isCustomerAdminSite(role ?? '')" size="sm" @click="onSalesRepDelete(salesRep)"><b-icon-trash></b-icon-trash></b-button>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Customers" v-if="_isCustomerAdminSite(role ?? '') || _isCustomerSite(site.Name)">
            <b-button @click="onAddPermissions('Customer')" size="sm" variant="info" class="background-color-primary mb-2" v-if="_isCustomerAdminSite(role ?? '')">
              <b-icon icon="plus"></b-icon>
              Customer
            </b-button>
            <b-button v-if="_isCustomerSite(site.Name)" size="sm" variant="info" class="background-color-primary mb-2" @click="onAddPermissions('Customer')">
              <b-icon icon="plus"></b-icon>
              Request Permissions
            </b-button>
            <b-row class="justify-content-between align-items-center p-1 border-y" style="
                    background-color: #e7f0f8;
                    border-color: #a6c2ef;
                    margin-left: -1.25rem;
                    margin-right: -1.25rem;
                  ">
              <b-col sm="2"><b>Customer Number</b></b-col>
              <b-col sm="3"><b>Customer Name</b></b-col>
              <b-col sm="2"><b>City</b></b-col>
              <b-col sm="2"><b>State</b></b-col>
              <b-col sm="2"><b>Zipcode</b></b-col>
              <b-col sm="1"></b-col>
            </b-row>
            <b-row class="my-2" v-if="!user.CustomerPermissions.length">
              <b-col>This user has no customer</b-col>
            </b-row>
            <b-row class="my-2" v-for="customer in user.CustomerPermissions" :key="customer.Id">
              <b-col sm="2">
                <router-link :to="{
                  name: 'customer',
                  params: { customerNumber: customer.ResourceId },
                }">
                  {{ customer.ResourceId }}
                </router-link>
              </b-col>
              <b-col sm="3">
                {{ customer.ResourceName }}
              </b-col>
              <b-col sm="2">
                {{ customer.City }}
              </b-col>
              <b-col sm="2">
                {{ customer.State }}
              </b-col>
              <b-col sm="2">
                {{ customer.PostalCode }}
              </b-col>
              <b-col sm="1">
                <b-button v-if="_isCustomerAdminSite(role ?? '')" size="sm" @click="onCustomerDelete(customer)"><b-icon-trash></b-icon-trash></b-button>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Approval Requests">
            <div class="row">
              <b-card :class="_isCustomerAdminSite(role ?? '') ? 'col-sm-6' : 'col-sm-12'" v-if="_isCustomerAdminSite(role ?? '') ||_isSalesRepSite(site.Name)">
                <b-card-header>
                  SalesRep Approval Requests
                </b-card-header>
                <b-card-body>
                  <b-row v-if="user.SalesRepPermissionRequests.filter(x => x.Status == '1').length === 0">
                    This user has no pending requests
                  </b-row>
                  <b-table v-else :fields="salesRepPendingRequestsFields" :items="user.SalesRepPermissionRequests.filter(x => x.Status == '1')" responsive hover borderless class="order-table" thead-class="th-custom-class">
                    <template #table-busy>
                      <div class="text-center my-2">
                        <b-spinner class="align-middle primary-color mr-2"></b-spinner>
                        <strong class="primary-color">Loading...</strong>
                      </div>
                    </template>
                    <template v-slot:cell(SalesRepresentativeNumber)="{ item }">
                      <router-link :to="{
                        name: _isCustomerAdminSite(role ?? '') ? 'sales-rep-profile' : 'sales-rep-profile-single',
                        params: { salesRepNumber: item.SalesRepresentativeNumber },
                      }">
                        {{ item.SalesRepresentativeNumber }}
                      </router-link><br>
                      {{ item.SalesRepresentativeName }}
                    </template>
                    <template v-slot:cell(PermissionRequests)="{ item }">
                      <template v-if="item.Status === 1">
                        {{ item.UserEmail }}
                        <br>
                        <b-button v-if="_isCustomerAdminSite(role ?? '')" class="mr-1" variant="outline-success" @click="onSalesRepApprove(item)">
                          <b-icon icon="check-circle" /> Approve
                        </b-button>
                        <b-button v-if="_isCustomerAdminSite(role ?? '')" variant="outline-danger" @click="onSalesRepReject(item)">
                          <b-icon icon="x-circle" /> Reject
                        </b-button>
                      </template>
                    </template>
                    <template v-slot:cell(RejectionReason)="{ item }">
                      {{ item.RejectionReason }}
                    </template>
                  </b-table>
                </b-card-body>
              </b-card>
              <b-card :class="_isCustomerAdminSite(role ?? '') ? 'col-sm-6' : 'col-sm-12'" v-if="_isCustomerAdminSite(role ?? '') || _isCustomerSite(site.Name)">
                <b-card-header>
                  Customer Approval Requests
                </b-card-header>
                <b-card-body>
                  <b-row v-if="user.CustomerPermissionRequests.filter(x => x.Status == '1' || x.Status == '5').length === 0">
                    This user has no pending requests
                  </b-row>
                  <b-table v-else :fields="customerPendingRequestsFields" :items="user.CustomerPermissionRequests.filter(x => x.Status == '1' || x.Status == '5')" responsive hover borderless class="order-table" thead-class="th-custom-class">
                    <template #table-busy>
                      <div class="text-center my-2">
                        <b-spinner class="align-middle primary-color mr-2"></b-spinner>
                        <strong class="primary-color">Loading...</strong>
                      </div>
                    </template>
                    <template v-slot:cell(CustomerNumber)="{ item }">
                      <router-link :to="{ name: 'customer', params: { customerNumber: item.CustomerNumber } }">
                        {{ item.CustomerNumber }}
                      </router-link><br>
                      {{ item.CustomerName }}
                    </template>
                    <template v-slot:cell(PermissionRequests)="{ item }">
                      <template v-if="item.Status === 1">
                        {{ item.UserEmail }}
                        <br>
                        <b-button v-if="_isCustomerAdminSite(role ?? '')" class="mr-1" variant="outline-success" @click="onCustomerApprove(item)">
                          <b-icon icon="check-circle" /> Approve
                        </b-button>
                        <b-button v-if="_isCustomerAdminSite(role ?? '')" variant="outline-danger" @click="onCustomerReject(item)">
                          <b-icon icon="x-circle" /> Reject
                        </b-button>
                      </template>
                      <template v-if="item.Status === 5">
                        <strong>Waiting for Sales Rep Approval</strong>
                      </template>
                    </template>
                    <template v-slot:cell(RejectionReason)="{ item }">
                      {{ item.RejectionReason }}
                    </template>
                  </b-table>
                </b-card-body>
              </b-card>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <ApproveRejectComponent :show="showSalesRepRejectModal" :email="salesRepRequestToReject?.UserEmail" :name="salesRepRequestToReject?.SalesRepresentativeName" :number="salesRepRequestToReject?.SalesRepresentativeNumber" :modalTitle="'Please add the reason to reject'" @ok="salesRepRejectPermission" :status="'reject'" :userType="'Sales Representative'" @close="closeModal()">
    </ApproveRejectComponent>
    <ApproveRejectComponent :show="showSalesRepApproveModal" :email="salesRepRequestToApprove?.UserEmail" :name="salesRepRequestToApprove?.SalesRepresentativeName" :number="salesRepRequestToApprove?.SalesRepresentativeNumber" :modalTitle="'Are you sure you want to approve?'" @ok="salesRepApprovePermission" :status="'approve'" :userType="'Sales Representative'" @close="closeModal()">
    </ApproveRejectComponent>
    <ApproveRejectComponent :show="showCustomerRejectModal" :email="customerRequestToReject?.UserEmail" :name="customerRequestToReject?.CustomerName" :number="customerRequestToReject?.CustomerNumber" :modalTitle="'Please add the reason to reject'" @ok="rejectPermissionCustomer" :status="'reject'" :userType="'Customer'" @close="closeModal()">
    </ApproveRejectComponent>
    <ApproveRejectComponent :show="showCustomerApproveModal" :email="customerRequestToApprove?.UserEmail" :name="customerRequestToApprove?.CustomerName" :number="customerRequestToApprove?.CustomerNumber" :modalTitle="'Are you sure you want to approve?'" @ok="approvePermissionCustomer" :status="'approve'" :userType="'Customer'" @close="closeModal()">
    </ApproveRejectComponent>
    <b-modal v-if="showActivateModal && userToActivate" :title="!newUserStatus ? 'Please confirm: should this user account be unlocked?' : 'Please confirm: should this user account be locked?'" v-model="showActivateModal" size="sm" centered no-close-on-backdrop @cancel="showActivateModal = false" @close="showActivateModal = false" @ok="activateUser(userToActivate, newUserStatus)">
      <div>
        <p>
          <b>User Name:</b> {{ userToActivate.Username }}
        </p>
        <b-form-group label="Comment*" label-for="comment">
          <b-form-input id="comment" v-model="comment" placeholder="Comment" :state="isValidRejectionReason()"></b-form-input>
          <b-form-invalid-feedback>Please add a comment</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal v-if="showDeleteCustomerConfirm" title="Are you sure to delete? Please add the comment." v-model="showDeleteCustomerConfirm" size="sm" centered no-close-on-backdrop>
      <div>
        <p>
          <b>{{ userToDelete?.ResourceId }} </b>
        </p>
        <b>{{ userToDelete?.ResourceName }} </b>
        <b-form-group label="Comment*" label-for="comment">
          <b-form-input id="comment" v-model="comment" placeholder="Comment" :state="comment.length > 0"></b-form-input>
        </b-form-group>
      </div>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right mx-1"
          @click="showDeleteCustomerConfirm = false">
          Cancel
        </b-button>
        <b-button
          :disabled="comment.length === 0"
          variant="primary"
          size="sm"
          class="float-right mx-1"
          @click="deleteCustomer(userToDelete.ResourceId, user.UserId, comment)">
          OK
        </b-button>
      </template>
    </b-modal>
    <b-modal v-if="showDeleteSalesRepConfirm" title="Are you sure to delete? Please add the comment" v-model="showDeleteSalesRepConfirm" size="sm" centered no-close-on-backdrop>
      <div>
        <p>
          <b>{{ userToDelete?.ResourceId }} </b>
        </p>
        <b>{{ userToDelete?.ResourceName }} </b>
        <b-form-group label="Comment*" label-for="comment">
          <b-form-input id="comment" v-model="comment" placeholder="Comment" :state="comment.length > 0"></b-form-input>
        </b-form-group>
      </div>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right mx-1"
          @click="showDeleteSalesRepConfirm = false">
          Cancel
        </b-button>
        <b-button
          :disabled="comment.length === 0"
          variant="primary"
          size="sm"
          class="float-right mx-1"
          @click="deleteSalesRep(userToDelete.ResourceId, user.UserId, comment)">
          OK
        </b-button>
      </template>
    </b-modal>
    <b-modal v-if="showAddPermissions" :title="typeUserToAdd === 'SalesRep' ? 'Please type the sales representative number' : 'Please type the customer number'" v-model="showAddPermissions" size="md" centered no-close-on-backdrop scrollable>
      <template v-if="_isSalesRepSite(site.Name) || _isCustomerAdminSite(role ?? '') || _isCustomerSite(site.Name)">
        <b-card>
          <b-row class="my-2">
            <b-col md="12" class="info-section" style="border-color: #a6c2ef">
              <b-row
                class="justify-content-between align-items-center p-1 border-y"
                style="
                  background-color: #e7f0f8;
                  border-color: #a6c2ef;
                  margin-left: -1.25rem;
                  margin-right: -1.25rem;
                ">
                <template v-if="_isSalesRepSite(site.Name) && typeUserToAdd === 'SalesRep'">
                  <b-col><b>Request permissions to sales representative id(s)</b></b-col>
                </template>
                <template v-if="_isCustomerSite(site.Name) && typeUserToAdd === 'Customer'">
                  <b-col><b>Request permissions to sales customer id(s)</b></b-col>
                </template>
                <template v-if="_isCustomerAdminSite(role ?? '')">
                  <b-col v-if="typeUserToAdd === 'SalesRep'"><b>Add permissions to sales representative id(s)</b></b-col>
                  <b-col v-if="typeUserToAdd === 'Customer'"><b>Add permissions to customer id(s)</b></b-col>
                </template>
              </b-row>
              <template v-if="typeUserToAdd === 'SalesRep'">
                <b-row class=" my-2" v-for="(salesRepId, index) in salesRepIdRequests" v-bind:key="'sales_rep_id' + index">
                  <b-col sm="10" class="pl-0">
                    <b-form-input id="login-sales-representative-id" v-model="salesRepIdRequests[index]" placeholder="Type your sales representative id" :state="isValidInput(salesRepId)"></b-form-input>
                    <b-form-invalid-feedback>Please enter a sales representative id</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="2" class="text-center">
                    <b-button @click="removeSalesRep(index)"><b-icon-trash></b-icon-trash></b-button>
                  </b-col>
                </b-row>
                <div class="mt-2 mb-2 text-right">
                  <a @click="addSalesRepresentative()" role="button" class="add-section-table-action">Add another sales representative id <b-icon icon="plus-square" variant="info" aria-hidden="true"></b-icon></a>
                </div>
              </template>
              <template v-if="typeUserToAdd === 'Customer'">
                <b-row class=" my-2" v-for="(customerId, index) in customerNumberRequests" v-bind:key="'customer_id' + index">
                  <b-col sm="10" class="pl-0">
                    <b-form-input id="login-customer-id" v-model="customerNumberRequests[index]" placeholder="Type your customer id" :state="isValidInput(customerId)"></b-form-input>
                    <b-form-invalid-feedback>Please enter a customer id</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="2" class="text-center">
                    <b-button @click="removeCustomer(index)"><b-icon-trash></b-icon-trash></b-button>
                  </b-col>
                </b-row>
                <div class="mt-2 mb-2 text-right">
                  <a @click="addCustomer()" role="button" class="add-section-table-action">Add another customer id <b-icon icon="plus-square" variant="info" aria-hidden="true"></b-icon></a>
                </div>
              </template>
            </b-col>
          </b-row>
        </b-card>
      </template>
      <template #modal-footer>
        <b-row>
          <b-button @click="showAddConfirmation(typeUserToAdd)" variant="primary" :disabled="isLoading">
            <template v-if="isLoading">
              <loading loadingText="Submitting"></loading>
            </template>
            <template v-else-if="_isSalesRepSite(site.Name) || _isCustomerSite(site.Name)">
              Request Permissions
            </template>
            <template v-else>
              {{ typeUserToAdd === 'SalesRep' ? 'Add SalesRep Id' : 'Add Customer Id' }}
            </template>
          </b-button>
        </b-row>
      </template>
    </b-modal>
    <b-modal v-model="showAddConfirmationMessage" size="md" @ok="requestPermissions()" @hide="showAddConfirmationMessage = false" dialog-class="float-md-center">
      <template #modal-header>
        {{ typeUserToAdd === 'SalesRep' ? 'Are you sure you want to add the following Sales Rep Account(s)?' : 'Are you sure you want to add the following Customer Account(s)?' }}
      </template>
      <template v-if="typeUserToAdd === 'SalesRep'">
        <span class="text-info">
          The Sales Rep account that you are requesting permission for is:
        </span>
        <br>
        <span class="text-info">
          {{ salesReps }}
        </span>
      </template>
      <template v-if="typeUserToAdd === 'Customer'">
        <span class="text-info">
          The Customer account that you are requesting permission for is:
        </span>
        <br>
        <span class="text-info">
          {{ customers }}
        </span>
      </template>
    </b-modal>
    <b-modal v-model="showAddConfirmationRequest" size="md" @ok="redirect()" @hide="showAddConfirmationRequest = false" dialog-class="float-md-center" ok-only>
      <template #modal-header>
        Confirmation
      </template>
      <h3>
        Thanks for submitting your request
      </h3>
      <span class="text-info">Your account approval is pending. Please check your email for updates.</span>
    </b-modal>
  </b-container>
</template>

<script lang="ts">
import { Component, Mixins, Watch } from 'vue-property-decorator'
import MxSite from '@/mixins/site'
import { namespace } from 'vuex-class'
import LoadingOverlay from '@/components/utility/loading-overlay.vue'
import { Api } from '@/api/Api'
import { IUser } from '../store/users/types'
import { TPIException } from '@/store/editor/types'
import { HttpMethod } from '@/api/FetchApi'
import ApproveRejectComponent from '@/components/modals/ApproveRejectPermissions.vue'

const nsUsers = namespace('users')

@Component({
  components: {
    LoadingOverlay,
    ApproveRejectComponent,
  },
})
export default class SalesRep extends Mixins(MxSite) {
  private api = new Api()

  @nsUsers.Getter('user')
  public user!: IUser

  @nsUsers.State('loading')
  public loading!: boolean

  @nsUsers.Getter('errorMessage')
  public errorMessage!: string

  @nsUsers.Action('getUserById')
  public getUserById: any

  @nsUsers.Action('getCurrentUserProfile')
  public getCurrentUserProfile: any

  @nsUsers.Action('requestPermissionsForUser')
  public requestPermissionsForUser: any

  @nsUsers.Action('addPermissionsForUser')
  public addPermissionsForUser: any

  @nsUsers.Action('getSalesRepListByNumber')
  public getSalesRepListByNumber: any

  @nsUsers.Action('getCustomerListByNumber')
  public getCustomerListByNumber: any

  @nsUsers.Action('saveUserProfile')
  public saveUserProfile: any

  public didSubmit: boolean = false

  public rejectionReason: string | null = null

  public salesRepIdRequests: string[] = ['']
  public salesReps: string = ''
  public customers: string = ''

  public customerNumberRequests: string[] = ['']

  public isLoading: boolean = false

  private emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

  public getPermissionStatusString(status: number) {
    let statusString = ''

    switch (status) {
      case 1:
        statusString = 'Pending approval'
        break
      case 2:
        statusString = 'Approved'
        break
      case 3:
        statusString = 'Rejected'
        break
    }

    return statusString
  }

  public showAddConfirmation(typeUserToAdd: string) {
    this.isLoading = true
    if (typeUserToAdd === 'SalesRep') {
      this.getSalesRepListByNumber({ salesRepIds: this.salesRepIdRequests }).then((salesRepresentativesList: any) => {
        if (salesRepresentativesList.length === 0) {
          this.toastError('The permissions request is invalid')
        }
        this.salesReps = ''
        this.salesReps += salesRepresentativesList.map(x => x.Id + ' - ' + x.Name + '\n')
        this.showAddConfirmationMessage = true
        this.isLoading = false
      })
    } else if (typeUserToAdd === 'Customer') {
      this.getCustomerListByNumber({ customerIds: this.customerNumberRequests }).then((customersList: any) => {
        if (customersList.length === 0) {
          this.toastError('The permissions request is invalid')
        }
        this.customers = ''
        this.customers += customersList.map(x => x.CustomerNumber + ' - ' + x.CustomerName + '\n')
        this.showAddConfirmationMessage = true
        this.isLoading = false
      })
    }
  }

  public requestPermissions() {
    let { salesRepIdRequests, customerNumberRequests } = this
    if (!this.areCustomerNumbersValid && !this.areSalesRepIdsValid) {
      this.toastError('The permissions request is invalid')
      this.isLoading = false
      return
    }
    if (this.salesRepAlreadyExists()) {
      return
    }

    if (this.customerAlreadyExists()) {
      return
    }

    if (this._isSalesRepSite(this.site.Name)) {
      this.requestPermissionsForUser({ salesRepIds: salesRepIdRequests, customerNumbers: customerNumberRequests }).then(() => {
        this.showAddConfirmationRequest = true
        salesRepIdRequests = ['']
        this.loadUserProfile()
      }).catch(({ Message }: TPIException) => {
        this.toastError(Message)
      }).finally(() => {
        this.isLoading = false
      })
    } else if (this._isCustomerSite(this.site.Name)) {
      this.requestPermissionsForUser({ salesRepIds: salesRepIdRequests, customerNumbers: customerNumberRequests }).then(() => {
        this.showAddConfirmationRequest = true
        customerNumberRequests = ['']
        this.loadUserProfile()
      }).catch(({ Message }: TPIException) => {
        this.toastError(Message)
      }).finally(() => {
        this.isLoading = false
      })
    } else if (this._isCustomerAdminSite(this.role ?? '')) {
      this.addPermissionsForUser({ salesRepIds: salesRepIdRequests, customerNumbers: customerNumberRequests, userId: this.user.UserId }).then(() => {
        this.toastSuccess('Permissions added successfully')
        salesRepIdRequests = ['']
        customerNumberRequests = ['']
        this.loadUserProfile()
      }).catch(({ Message }: TPIException) => {
        this.toastError(Message)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }

  redirect() {
    const { $router } = this
    if ((this._isSalesRepSite(this.site.Name) && this.user.SalesRepPermissions.length > 0) || (this._isCustomerSite(this.site.Name) && this.user.CustomerPermissions.length > 0)) {
      $router.push('/')
    } else {
      this.logout().then(() => {
        $router.replace('/authentication/login')
      })
    }
  }

  public salesRepAlreadyExists() {
    const duplicates: any[] = []

    this.salesRepIdRequests.forEach((item) => {
      if (this.user.SalesRepPermissions.some((obj) => obj.ResourceId.replace(/^0+|0+$/g, '') === item.replace(/^0+|0+$/g, ''))) {
        duplicates.push(item)
      }
      duplicates.forEach((index) => {
        this.salesRepIdRequests.splice(index, 1)
      })
    })

    if (duplicates.length > 0) {
      this.toastSuccess('These Sales Representative already exists ' + JSON.stringify(duplicates).split(';'))
      return true
    } else {
      return false
    }
  }

  public customerAlreadyExists() {
    const duplicates: any[] = []

    this.customerNumberRequests.forEach((item) => {
      if (this.user.CustomerPermissions.some((obj) => obj.ResourceId.replace(/^0+|0+$/g, '') === item.replace(/^0+|0+$/g, ''))) {
        duplicates.push(item)
      }
      duplicates.forEach((index) => {
        this.customerNumberRequests.splice(index, 1)
      })
    })

    if (duplicates.length > 0) {
      this.toastSuccess('These customers already exists ' + JSON.stringify(duplicates).split(';'))
      return true
    } else {
      return false
    }
  }

  public async mounted() {
    this.loadUserProfile()
  }

  public isValidRejectionReason() {
    return this.rejectionReason && this.rejectionReason !== ''
  }

  public loadCustomer(customerNumber: string) {
    this.$router.push({
      name: 'customer',
      params: { customerNumber },
    })
  }

  public addSalesRepresentative() {
    const { salesRepIdRequests } = this
    salesRepIdRequests.push('')
  }

  public addCustomer() {
    const { customerNumberRequests } = this
    customerNumberRequests.push('')
  }

  public removeSalesRep(index: number) {
    let { salesRepIdRequests } = this

    if (salesRepIdRequests.length === 1) {
      salesRepIdRequests = ['']
    } else if (salesRepIdRequests.length > index) {
      salesRepIdRequests.splice(index, 1)
    }
  }

  public removeCustomer(index: number) {
    let { customerNumberRequests } = this

    if (customerNumberRequests.length === 1) {
      customerNumberRequests = ['']
    } else if (customerNumberRequests.length > index) {
      customerNumberRequests.splice(index, 1)
    }
  }

  public isValidInput(value: string): boolean | null {
    return !this.didSubmit
      ? null
      : (value ?? '').length > 0
  }

  public showSalesRepApproveModal = false
  public showSalesRepRejectModal = false
  public showCustomerApproveModal = false
  public showCustomerRejectModal = false
  public showActivateModal = false
  public showDeleteCustomerConfirm = false
  public showDeleteSalesRepConfirm = false
  public showAddPermissions = false
  public showAddConfirmationMessage = false
  public showAddConfirmationRequest = false

  public salesRepRequestToReject: { Id: string, UserEmail: string, SalesRepresentativeName: string, SalesRepresentativeNumber: string } | null = null
  public salesRepRequestToApprove: { Id: string, UserEmail: string, SalesRepresentativeName: string, SalesRepresentativeNumber: string } | null = null
  public customerRequestToReject: { Id: string, UserEmail: string, CustomerName: string, CustomerNumber: string } | null = null
  public customerRequestToApprove: { Id: string, UserEmail: string, CustomerName: string, CustomerNumber: string } | null = null
  public userToActivate: { Username: string, UserId: string, Comment: string } | null = null
  public userToDelete: { ResourceId: string, ResourceName: string } | null = null
  public newUserStatus = false
  public typeUserToAdd = ''
  public comment = ''
  public userDisabled = false

  public onSalesRepApprove(item: any) {
    this.salesRepRequestToApprove = item
    this.showSalesRepApproveModal = true
  }

  public onSalesRepReject(item: any) {
    this.salesRepRequestToReject = item
    this.showSalesRepRejectModal = true
  }

  public onCustomerApprove(item: any) {
    this.customerRequestToApprove = item
    this.showCustomerApproveModal = true
  }

  public onCustomerReject(item: any) {
    this.customerRequestToReject = item
    this.showCustomerRejectModal = true
  }

  public onCustomerDelete(item: any) {
    this.userToDelete = item
    this.showDeleteCustomerConfirm = true
  }

  public onSalesRepDelete(item: any) {
    this.userToDelete = item
    this.showDeleteSalesRepConfirm = true
  }

  public salesRepRejectPermission(rejectionReason: string) {
    const obj = { isApproved: false, rejectionStatus: rejectionReason, PermissionIds: [this.salesRepRequestToReject?.Id] }
    this.api.fetchV2({
      url: '/sales-rep/permission-requests/batchRespond',
      obj,
      method: HttpMethod.Post,
    }).then(() => {
      this.toastSuccess('Updated successfully')
      this.loadUserProfile()
      this.closeModal()
    })
  }

  public salesRepApprovePermission() {
    const obj = { isApproved: true, PermissionIds: [this.salesRepRequestToApprove?.Id] }
    this.api.fetchV2({
      url: '/sales-rep/permission-requests/batchRespond',
      obj,
      method: HttpMethod.Post,
    }).then(() => {
      this.toastSuccess('Updated successfully')
      this.loadUserProfile()
      this.closeModal()
    })
  }

  public rejectPermissionCustomer(rejectionReason: string) {
    const obj = { isApproved: false, rejectionStatus: rejectionReason, PermissionIds: [this.customerRequestToReject?.Id] }
    this.api.fetchV2({
      url: '/customer/permission-requests/batchRespond',
      obj,
      method: HttpMethod.Post,
    }).then(() => {
      this.loadUserProfile()
      this.closeModal()
    })
  }

  public approvePermissionCustomer() {
    this.api.fetchV2({
      url: '/customer/permission-requests/batchRespond',
      obj: { isApproved: true, PermissionIds: [this.customerRequestToApprove?.Id] },
      method: HttpMethod.Post,
    }).then(() => {
      this.loadUserProfile()
      this.closeModal()
    })
  }

  public deleteCustomer(number: string, userId: number, comment) {
    this.api.fetchV2({
      url: '/customer/delete/',
      obj: { Number: number, UserId: userId, Comment: comment },
      method: HttpMethod.Post,
    }).then(response => {
      if (!response.Successful) {
        this.toastError('Deleted unsuccessfully')
      } else {
        this.toastSuccess('Updated successfully')
        this.loadUserProfile()
        this.showDeleteCustomerConfirm = false
      }
      this.comment = ''
    })
  }

  public deleteSalesRep(number: string, userId: number, comment) {
    this.api.fetchV2({
      url: '/sales-rep/delete/',
      obj: { Number: number, UserId: userId, Comment: comment },
      method: HttpMethod.Post,
    }).then(response => {
      if (!response.Successful) {
        this.toastError('Deleted unsuccessfully')
      } else {
        this.toastSuccess('Updated successfully')
        this.loadUserProfile()
        this.showDeleteSalesRepConfirm = false
      }
      this.comment = ''
    })
  }

  public async onActivate() {
    await this.$nextTick()
    this.userDisabled = this.user.Disabled
    this.newUserStatus = !this.user.Disabled
    this.userToActivate = this.user as any
    this.showActivateModal = true
  }

  public onAddPermissions(typeUserToAdd: string) {
    this.showAddPermissions = true
    this.typeUserToAdd = typeUserToAdd
    this.customerNumberRequests = ['']
    this.salesRepIdRequests = ['']
    this.salesReps = ''
    this.customers = ''
  }

  public validateUser() {
    return (this.user?.Name !== null && this.user?.Name?.length > 0) && (this.emailRegex.test(this.user.Email ?? '')) && (this.user?.LastName !== null && this.user?.LastName?.length > 0)
  }

  public saveProfile() {
    this.isLoading = true
    this.saveUserProfile({ user: this.user }).then(() => {
      this.toastSuccess('Updated successfully')
    }).catch(() => {
      this.toastError('Updated unsuccessfully')
    }).finally(() => {
      this.isLoading = false
    })
  }

  public activateUser(user: any, disabled: boolean) {
    this.api.fetchV2({
      url: `/user/activate/${user.UserId}`,
      obj: { Comment: this.comment, Disabled: disabled },
      method: HttpMethod.Post,
    }).then(response => {
      if (!response.Successful) {
        this.toastError('Updated unsuccessfully')
      } else {
        this.toastSuccess('Updated successfully')
        this.getUserById(this.Username)
      }
      this.comment = ''
    })
  }

  @Watch('user', { deep: true })
  public userStatusChanged() {
    this.userDisabled = this.user.Disabled
  }

  private async loadUserProfile() {
    this._isCustomerAdminSite(this.role ?? '')
      ? await this.getUserById(this.Username)
      : await this.getCurrentUserProfile()
  }

  get Username() {
    return this.$route.params.username
  }

  private get areSalesRepIdsValid() {
    for (let index = 0; index < this.salesRepIdRequests.length; index++) {
      if (this.salesRepIdRequests[index] === '') return false
    }

    return true && (this._isSalesRepSite(this.site.Name) || this._isCustomerAdminSite(this.role ?? '')) && this.salesRepIdRequests.length > 0
  }

  private get areCustomerNumbersValid() {
    for (let index = 0; index < this.customerNumberRequests.length; index++) {
      if (this.customerNumberRequests[index] === '') return false
    }

    return true && (this._isCustomerSite(this.site.Name) || this._isCustomerAdminSite(this.role ?? '')) && this.customerNumberRequests.length > 0
  }

  public closeModal() {
    this.showSalesRepApproveModal = false
    this.showSalesRepRejectModal = false
    this.showCustomerApproveModal = false
    this.showCustomerRejectModal = false
  }

  public salesRepPendingRequestsFields = [
    {
      key: 'SalesRepresentativeNumber',
      label: 'Sales Rep',
      thClass: 'responsive-col text-left',
      tdClass: 'text-left',
      thStyle: 'resp-th-20',
    },
    {
      key: 'RejectionReason',
      label: 'Account Notes',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: 'resp-th-20',
    },
    {
      key: 'PermissionRequests',
      label: 'Permission Requests',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: 'resp-th-20',
    },
  ]

  public customerPendingRequestsFields = [
    {
      key: 'CustomerNumber',
      label: 'Customer',
      thClass: 'responsive-col text-left',
      tdClass: 'text-left',
      thStyle: 'resp-th-20',
    },
    {
      key: 'RejectionReason',
      label: 'Account Notes',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: 'resp-th-20',
    },
    {
      key: 'PermissionRequests',
      label: 'Permission Requests',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: 'resp-th-20',
    },
  ]
}

</script>
<style scoped></style>
